import { FOCUS_ALLOW as e } from "./constants.js";
import { contains as f } from "./utils/DOMutils.js";
import { toArray as i } from "./utils/array.js";
import { getActiveElement as m } from "./utils/getActiveElement.js";
var p = function (r) {
  r === void 0 && (r = document);
  var t = m(r);
  return t ? i(r.querySelectorAll("[".concat(e, "]"))).some(function (o) {
    return f(o, t);
  }) : !1;
};
export { p as focusIsHidden };